const LogoIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" opacity=".9" />
    <path fill="#FFFFFF" d="M12 7.2l4 2.3v5L12 16.8l-4-2.3v-5z" />
  </svg>
);

export default LogoIcon;
